// For consistency - use this file for helpText (tooltips) and other common property controls

export const ANIMATE_LOADING_PROPERTY_CONTROL_HELP_TEXT =
  "Display a loading animation if dependent data is loading";

export const LABEL_POSITION_PROPERTY_CONTROL_HELP_TEXT =
  "Position the label above or to the side of the input";
